module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('company-details', {
    attrs: {
      "company": _vm.myCompany,
      "groups": _vm.groups,
      "loading": _vm.$apollo.queries.myCompany.loading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('plugins-list', {
    attrs: {
      "plugins": _vm.plugins,
      "loading": _vm.loadingPlugins
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('generate-u-r-l', {
    attrs: {
      "companyUsers": _vm.companyUsers,
      "activeCampaigns": _vm.activeCampaigns,
      "generatedUrl": _vm.generatedUrl,
      "generateUrlSuccess": _vm.generateUrlSuccess,
      "loadingGenerateUrl": _vm.loadingGenerateUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.hasPermissionPlugin) ? _c('generate-permission-u-r-l') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('user-list', {
    staticClass: "user-list",
    attrs: {
      "users": _vm.companyUsers,
      "groups": _vm.groups
    }
  }), _vm._v(" "), _c('timeslot-list', {
    attrs: {
      "timeslots": _vm.timeslots
    }
  }), _vm._v(" "), _c('blacklist-originator-list', {
    attrs: {
      "blacklistedOriginators": _vm.blacklistedOriginators
    }
  }), _vm._v(" "), _c('email-recipient-list', {
    staticClass: "recipient-list",
    attrs: {
      "me": _vm.me,
      "campaigns": _vm.campaigns,
      "companies": _vm.myCompanies,
      "surveys": _vm.surveys,
      "recipients": _vm.recipients,
      "users": _vm.emailUsers,
      "loading": _vm.$apollo.queries.recipients.loading
    },
    on: {
      "deleted": _vm.refetchRecipients,
      "saved": _vm.refetchRecipients
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36b29dab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/company/CompanyDashboard.vue
// module id = 3218
// module chunks = 3